import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { BackgroundLoader } from './background-loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  private _madeRequests: number;

  private _hideLoaderTimeout: any;

  constructor(private loader: BackgroundLoader) {
    this._madeRequests = 0;
  }

  public intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    
    if (httpRequest.url.includes("CheckStatusImport")) {
      return next.handle(httpRequest);
    }

    this._madeRequests++;

    clearTimeout(this._hideLoaderTimeout);

    if (this._madeRequests > 0 && !this.loader.isShowing) {
      this.loader.show();
    }
    return next
      .handle(httpRequest)
      .pipe(
        finalize(() => {
          this.hideLoader();
        })
      );
  }

  protected hideLoader() {
    this._madeRequests--;

    if (this._madeRequests > 0) {
      return;
    }

    if (!this.loader.isShowing) {
      return;
    }

    clearTimeout(this._hideLoaderTimeout);
      this._hideLoaderTimeout = <any>setTimeout(() => {
      this.loader.hide();
      this._madeRequests = 0;
    }, 250);
  }

}
